import React from 'react';
import { Card, Container, Row, Col } from 'reactstrap';
import { T } from '../../../traks';
import { formatDate, formatPrice } from '../Globals/GlobalUtils';

const CartItem = ({ line, defaultCurrency, setView, handleRemove }) => {
  return (
    <Card className='order-container p-3'>
      <Container>
        <Row className="align-items-center">
          <Col xs="10">
            <Row>
              <b className='ad_125pct mb-1'><T>Premium Key</T></b>
            </Row>
            <Row className='mb-1'>
              <img className='mr-2 cart-item-icon' src='https://static.aktiedysten.dk/gfx/user-icon-green-2023-0.svg' alt='icon' />
              <b><T>Invitations</T>&nbsp;</b>
              <span>x {line.keys}</span>
            </Row>
            <Row className='mb-1'>
              <img className='mr-2 cart-item-icon' src='/gfx/calendar-color-0.svg' alt='icon' />
              <b><T>Months</T>&nbsp;</b>
              <span>x {line.months}</span>
            </Row>
            <Row className='mb-1'>
              <img className='mr-2 cart-item-icon' src='/gfx/calendar-color-0.svg' alt='icon' />
              <b><T>Start Date</T>&nbsp;</b>
              <span>{formatDate(new Date(line.startDate))}</span>
            </Row>
            <Row className='mb-1'>
              <img className='mr-2 cart-item-icon' src='/gfx/calendar-color-0.svg' alt='icon' />
              <b><T>Premium valid until:</T>&nbsp;</b>
              <span>{formatDate(new Date(line.expirationDate))}</span>
            </Row>
            {line.game && (
                <Row className='mb-1'>
                    <img className='mr-2 cart-item-icon' src='/gfx/cup-frontpage-color-0.svg' alt='icon' />
                    <b><T>Game Upgrade</T>&nbsp;</b>
                    <span>{line.game}</span>
                </Row>
            )}
            <Row className='mt-1'>
              <b><T>Price:</T>&nbsp;</b>
              <span>{formatPrice(line.discountedTotal)} {defaultCurrency}&nbsp;</span>
              <span className='checkout-price-no-vat'>
                ({formatPrice(line.discountedTotalNoVat)} {defaultCurrency}&nbsp;<T>excl. VAT)</T>
              </span>
            </Row>
          </Col>
          <Col xs="2" className="text-right">
            <Row className='mb-2'>
              <a role="button" className='mr-2' onClick={() => setView('order')}>
                <img className='cart-icon' src="/gfx/gear-icon-0.svg" alt="Edit" />
                <T> Rediger</T>
              </a>
            </Row>
            <Row>
              <a role="button" className='mr-2' onClick={handleRemove}>
                <img className='cart-icon' src="/gfx/remove-portfolio-icon-1.svg" alt="Remove" />
                <T> Fjern</T>
              </a>
            </Row>
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default CartItem;


// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Cart/CartItem.js